module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-1x1-f79a3eac7ef07a7fe52db621554d1778.jpg";